import * as React from 'react'

import { Box, Colors, Text, colors, dimensions } from '@factorialco/deprecated-design-system'
import type moment from 'moment'

import { observer } from 'mobx-react'

import { useColor } from 'modules/shift_management/hooks/useColor'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { Shift } from 'modules/shift_management/lib/types'

import BaseCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/BaseCell'
import ShiftTime from './BaseShift/ShiftLayout/ShiftDetails/ShiftTime'

interface Props {
  nightShift: Shift
  date: moment.Moment
}

const DisabledNightShiftItem = ({ nightShift, date }: Props) => {
  const [{ view }] = useSchedule()
  const color = useColor(nightShift)
  const draftColor = view.isDaily ? 'grey000White' : 'lighter000'
  const background: Colors = nightShift.isDraft ? draftColor : color
  const boxShadow = nightShift.isDraft ? `0 0 0 ${dimensions.s2} ${colors[color]} inset` : ''

  return (
    <Box
      background={background}
      borderRadius={{ all: 'abs008' }}
      style={{
        opacity: '0.5',
        boxShadow: boxShadow,
      }}
    >
      <BaseCell
        minHeight={view.cellMinHeight}
        alignItems={view.isFullVersion ? 'flexStart' : 'center'}
        justifyContent={view.isFullVersion ? 'flexStart' : 'center'}
      >
        <ShiftTime shift={nightShift} date={date} plannedBreaks={[]} />
        {view.isByAreas && (
          <Box overflowX="hidden">
            <Text size="100" ellipsis>
              {nightShift.employeeFullName}
            </Text>
          </Box>
        )}
      </BaseCell>
    </Box>
  )
}

export default observer(DisabledNightShiftItem)
